export default __webpack_public_path__ + "static/media/fd18c6d26d4d9d26a0bd9d1a2fb2bd04.380d8431.png";